import { Snackbar } from '@mui/material';
import { AddToPhotos } from '@mui/icons-material';
import { Alert } from '@mui/material';
import { Col, Progress, Row } from 'antd';
import ModalMenu from "components/Modals";
import { ref as fireRef, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
import { storage } from 'firebaseConfig';
import { get } from "lodash";
import moment from "moment";
import React, { memo, useEffect, useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import { useCurrentUser } from "store/users/selectors";
import styled from 'styled-components';
import COLOR from "utils/constants/color";
import { getSizeInKBMb } from "utils/methods/math";
import { v4 } from 'uuid';
import * as Sentry from '@sentry/react';
import MultiFileUploader from "components/UI/admin/MultifileUploadGallery";
import { IMAGE_FILE_TYPE } from 'utils/constants/enum';
const MAX_FILE_SIZE = 10 * 1024 * 1024;

const ImageContainer = styled.div`
    // height: auto;
    flex: 1;
    //min-height: 25vh;
      @media (min-width:600px) and (max-width:1367px) {
        min-height: 15vh;
    }
    @media (max-width: 600px){
       min-height: 171px !important;
    }
`;

const Images = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    border-radius:8px;
    z-index: 9999;

    @media (min-width: 1024px) {
        max-height: 160px;
        max-width: 80%;
    }
     @media (max-width: 1024px) {
        max-height: 110px!important;
     }    
`;
const Container = styled.div`
    width: 100%;
    min-height: 10vh;
    display:block;
    align-item:center;
    justify-content:center;
    position: relative;
    background-color:${p => p.empty ? "rgba(0,0,0,0.1)" : "transparent"}
`;

const FileUploadArea = styled.div`
    height: 100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const Text = styled.div`
    font-size: 12px;
`;
const Column = styled(Col)`
display: flex;
    justify-content: center;
    align-items: center;
}
`
 const  MatchMakingImage = ({source, handlePicture, path, type , style={}, disabled=false, imageClassName = "",  containerClassName="",setButtonDisabled = (val)=> {} , showImagePicker }) => {
    const currentUser = useCurrentUser()
    const [pagePoster, setpagePoster] = useState();
    const [loader, setLoader] = useState(false);
    const [loadingMap, setLoadingMap] = useState(0);
    const[imageModal,setImageModal] = useState(false);
    const [alert, setAlert] = useState({
        open: false,
        message: "",
      });

    useEffect(() => {
        setpagePoster(source);
    }, [source])

    const uploadToStorage = async (file) => {
        if(disabled){
            return;
        }
        if (file) {
            if (file.size > MAX_FILE_SIZE &&  get(currentUser, "role") !== "owe_admin" ) {
                setAlert({
                    open: true,
                    message: `Your file size(${getSizeInKBMb(file?.size)}) exceeds the maximum limit of 10MB.`,
                  });
                return;
            }
            if(setButtonDisabled){
                setButtonDisabled(true);
            }
            const location = path ||'/picture/activity-submissions' ;
            const id = `${moment().format('YYYY-MM-DD')}-${v4()}${file.name}`;
            const fileRef = fireRef(storage, `${location}/${id}`);
    
            try {
                const uploadTask = uploadBytesResumable(fileRef, file); 
                uploadTask.on('state_changed',
                    (snapshot) => {
                        const per = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                        setLoadingMap(per);
                        setLoader(true);
                        if(setButtonDisabled){
                            setButtonDisabled(true);
                        }
                        
                    },
                    (error) => {
                        console.error("Upload error:", error);
                        setLoader(false);
                        setLoadingMap(0);
                    },
                    () => {
                        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                            setLoader(false);
                            if(setButtonDisabled){
                                setButtonDisabled(false);
                            }                         
                            setLoadingMap(0);
                            setpagePoster(downloadURL);
                            handlePicture(downloadURL);
                        });
                    }
                );
            } catch (error) {
                Sentry.captureException(`368 Upload error: ${error}`);
                console.error("Upload error:", error);
                setLoader(false);
                setLoadingMap(0);
                setButtonDisabled(false);
            }
            finally{
                if(setButtonDisabled){
                    setButtonDisabled(false);
                } 
            }
        } else {
            console.log("No file to upload.");
        }
    };

    const handleCloseAlert = () => {
        setAlert({
          open: false,
          message: "",
        });
      };
     const onSelectImage = (img) => {
         setLoader(false);
         if (setButtonDisabled) {
             setButtonDisabled(false);
         }
         setLoadingMap(0);
         setpagePoster(img);
         handlePicture(img);
     }
    return (
        <div>
        <ModalMenu type="imageModal" image={pagePoster} open={imageModal} close={() => setImageModal(false)}  />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={alert.open}
          autoHideDuration={5000}
          onClose={handleCloseAlert}
        >
        <Alert onClose={handleCloseAlert} severity="error">
          <strong>ALERT:</strong> {alert.message}
        </Alert>
      </Snackbar>
      <ImageContainer className={containerClassName} onContextMenu={(e) => { }} style={style}>
            <Container>
                <Images 
                  src={pagePoster} 
                  className={`cursor-zoomIn ${pagePoster ? 'showUploadImgCstm' : ''} ${imageClassName}`}
                  onClick={()=> setImageModal(true)} 
                  />
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {showImagePicker ? <MultiFileUploader inModal onSelect={onSelectImage} /> : null}
                </div>
                <FileUploader
                    classes={"file-uploader-cover file-uploader-coverCtm"}
                    handleChange={uploadToStorage}
                    name="file"
                    disabled={disabled}
                    types={IMAGE_FILE_TYPE}
                >
                    <FileUploadArea style={{cursor: disabled ? "default" : "pointer"}}>
                        {loader && <Progress type="line" percent={loadingMap} size={"small"} className={"fileProgress"} showInfo={false} />}
                        <Row className="box box-1" style={{ display: "flex", justifyContent: "space-between" }}>
                            <Column >
                                <AddToPhotos color="primary" />
                            </Column>
                            <Column>
                                <Text>
                                    Upload or drop a file right here
                                </Text>
                            </Column>
                            <Column>
                                <Text>
                                    {IMAGE_FILE_TYPE.join(",")}
                                </Text>
                            </Column>
                        </Row>
                    </FileUploadArea>
                </FileUploader>
            </Container>
        </ImageContainer>
        </div>
    )
}


export default memo(MatchMakingImage);